export default function AccountController($location) {
    $location.path("/account/profile");
}
